// extracted by mini-css-extract-plugin
export default {"Grid":"InsuranceList_Grid__1Wg1u"};